// *******************************************************
// SaladBowlIcon
// -------------------------------------------------------
// Component Description
//
// Link to icon:
//
// -------------------------------------------
// *******************************************
// Module Imports
// -------------------------------------------
import React, { ReactElement } from 'react';

// *******************************************
// Interface Imports
// -------------------------------------------
import IIconProp from '../../../iconInterface';

// *******************************************
// Main Component
// -------------------------------------------
export const SaladBowlIcon = ({
  className = 'h-full w-auto',
  fillColor = '#000',
}: IIconProp): ReactElement => {
  return (
    <svg
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={className}
    >
      <title>Groceries</title>
      <defs>
        <path
          d="M3.75188201,10.0051581 L6.61933604,10.0051581 L3.21919292,6.60501501 C3.09718942,6.48293152 3.09718942,6.2850799 3.21919292,6.16299641 L3.66160234,5.72058698 C3.78368584,5.59858348 3.98153745,5.59858348 4.10362095,5.72058698 L8.12907774,9.74604378 L8.12907774,4.0646782 C8.12907774,3.8920026 8.26905898,3.75202136 8.44173458,3.75202136 L9.06704826,3.75202136 C9.23972386,3.75202136 9.3797051,3.8920026 9.3797051,4.0646782 L9.3797051,10.0051581 L11.4330789,10.0051581 C11.3207962,9.59756461 11.2611671,9.17727112 11.2556461,8.75453078 C11.2586616,5.99297115 13.4965959,3.75503687 16.2581555,3.75202136 C16.3617231,3.75202136 16.4582559,3.77625227 16.5602602,3.7825054 C15.872806,3.00320823 14.8781664,2.50139401 13.7569008,2.50139401 C13.4241753,2.50597937 13.0935763,2.55527347 12.7739859,2.6479519 C12.0837335,1.04129455 10.503047,0 8.75439142,0 C7.00573586,0 5.42504937,1.04129455 4.73479694,2.6479519 C4.41520657,2.55527347 4.08460753,2.50597937 3.75188201,2.50139401 C1.67977478,2.50139404 0,4.18116885 0,6.25327607 C0,8.32538329 1.67977478,10.0051581 3.75188201,10.0051581 Z M12.5062693,8.75453078 C12.5103872,9.18151966 12.588128,9.60459884 12.7360763,10.0051581 L19.3522858,10.0051581 C19.4913581,10.0059108 19.6299131,10.0221652 19.7653836,10.0536199 C20.2874536,8.64815724 19.9214172,7.06679169 18.8348912,6.03366835 C17.7483653,5.00054502 16.1505738,4.71460451 14.7731836,5.30678582 C13.3957935,5.89896714 12.504038,7.25523848 12.5062693,8.75453078 L12.5062693,8.75453078 Z M19.3522858,11.2557855 L0.631957579,11.2557855 C0.273574678,11.2557855 -0.0289208135,11.5574993 0.00234487038,11.9139281 C0.261459225,14.8986285 2.27731419,17.3615827 5.00250936,18.317531 L5.00250936,18.7595496 C5.00250936,19.450252 5.5624343,20.010177 6.25313671,20.010177 L13.7569008,20.010177 C14.4476033,20.010177 15.0075282,19.450252 15.0075282,18.7595496 L15.0075282,18.3097146 C17.7198263,17.3475132 19.723175,14.8904212 19.9815077,11.9139281 C20.0123825,11.5574993 19.709887,11.2557855 19.3522858,11.2557855 L19.3522858,11.2557855 Z"
          id="path-1-groceries-ahdk"
        ></path>
      </defs>
      <g
        id="00-Micronaires/Icons/Groceries"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Colours/Black-#000000-groceries-ahdk"
          transform="translate(2.000000, 2.000000)"
        >
          <mask id="mask-2-groceries-ahdk" fill="white">
            <use xlinkHref="#path-1-groceries-ahdk"></use>
          </mask>
          <use
            id="Mask-groceries-ahdk"
            fill={fillColor}
            fillRule="nonzero"
            xlinkHref="#path-1-groceries-ahdk"
          ></use>
          <g id="Group-groceries-ahdk" mask="url(#mask-2-groceries-ahdk)">
            <g transform="translate(-12.000000, -12.000000)">
              <rect
                id="Rectangle-groceries-ahdk"
                fill={fillColor}
                x="0"
                y="0"
                className={className}
              ></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default SaladBowlIcon;
